import { render, staticRenderFns } from "./ImportAssetsModal.vue?vue&type=template&id=c0461c66&scoped=true"
import script from "./ImportAssetsModal.vue?vue&type=script&lang=js"
export * from "./ImportAssetsModal.vue?vue&type=script&lang=js"
import style0 from "./ImportAssetsModal.vue?vue&type=style&index=0&id=c0461c66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0461c66",
  null
  
)

export default component.exports